import axios from "axios";
import { ApiError, OpenAPI } from "@pro-sto/api-client";

async function resolveToken(): Promise<string> {
  const token = OpenAPI.TOKEN;
  if (typeof token === "function") {
    return (await token({ method: "POST", url: "" } as never)) ?? "";
  }
  return token ?? "";
}

async function postHelpLat(
  uuid: string,
  action: "send" | "sync",
): Promise<unknown> {
  const token = await resolveToken();
  try {
    const response = await axios.post(
      `${OpenAPI.BASE}/api/superadmin/help/orders/${uuid}/lat/${action}`,
      {},
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new ApiError(
        { method: "POST", url: `/api/superadmin/help/orders/${uuid}/lat/${action}` },
        {
          url: error.config?.url ?? "",
          ok: false,
          status: error.response.status,
          statusText: error.response.statusText,
          body: error.response.data,
        },
        error.message,
      );
    }
    throw error;
  }
}

export function superadminSendHelpOrderToLat(uuid: string): Promise<unknown> {
  return postHelpLat(uuid, "send");
}

export function superadminSyncHelpOrderFromLat(uuid: string): Promise<unknown> {
  return postHelpLat(uuid, "sync");
}
